/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Brokers_Will_LinkInputs */

const cs_import_stat_brokers_will_link = /** @type {(inputs: Import_Stat_Brokers_Will_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Makléři propojit: ${i?.count}`)
};

const en_import_stat_brokers_will_link = /** @type {(inputs: Import_Stat_Brokers_Will_LinkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brokers link: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Brokers link: {count}" |
*
* @param {Import_Stat_Brokers_Will_LinkInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_brokers_will_link = /** @type {((inputs: Import_Stat_Brokers_Will_LinkInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Brokers_Will_LinkInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_brokers_will_link(inputs)
	return cs_import_stat_brokers_will_link(inputs)
});